import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { SUPPORT_TICKETS_URL } from 'core/common/constants/settings'
import i18n from 'core/common/i18n'
import { Button } from 'core/components/Core'
import Loading from 'core/components/Loading'
import Result, { ResultActionArea } from 'core/components/Result'
import { getSeller } from 'core/services/http/products'

const SELLER_STATUS_ERROR = -1

/**
 * Verifica se seller existe na base do product
 */

const AppSellerExists = ({ children }) => {
  const [statusExistsSeller, setStatusExistsSeller] = useState(null)

  useEffect(() => {
    const checkSellerExists = async () => {
      try {
        const getSellerResponse = await getSeller()
        setStatusExistsSeller(getSellerResponse.status)
      } catch {
        setStatusExistsSeller(SELLER_STATUS_ERROR)
      }
    }

    checkSellerExists()
  }, [])

  if (statusExistsSeller === null) {
    return <Loading />
  }

  if (statusExistsSeller === 200) {
    return children
  }

  return (
    <Result
      status="403"
      title={i18n.t('error.SellerNotExists.title')}
      subtitle={i18n.t('error.SellerNotExists.subtitle')}
    >
      <ResultActionArea hasLogout>
        <Button target="_blank" href={SUPPORT_TICKETS_URL} variant="contained" color="primary">
          {i18n.t('error.SellerNotExists.labelAction')}
        </Button>
      </ResultActionArea>
    </Result>
  )
}

AppSellerExists.propTypes = {
  children: PropTypes.element.isRequired,
}

export default AppSellerExists
